module.exports = __webpack_public_path__ + "img/profile_teo_nk2.e581a8e2.jpg";